var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-button", on: { click: _vm.goToBIAnalyticsPage } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c("div", _vm._g({ staticClass: "home-button__icon" }, on), [
                    _c(
                      "svg",
                      {
                        staticStyle: {
                          "enable-background": "new 0 0 1080 1080",
                        },
                        attrs: {
                          id: "Layer_1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          x: "0px",
                          y: "0px",
                          height: "256px",
                          viewBox: "0 0 1080 1080",
                          "xml:space": "preserve",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M227.4,964.5c7.2,0.7,13.4,1.6,17.1,8.4c0.8,1.5,2.3,4.9,2.3,9.7c0,6.9-3.1,13.6-8.7,17.3\n\t\tc-1.7,1.1-3.1,1.8-7.1,3.1c1.9,0.3,4.6,0.9,6.3,1.5c10.4,3.9,11,13.5,11,17.1c0,1.3-0.1,3.1-0.7,5.7c-0.3,2.1-1.5,6.6-5.6,10.7\n\t\tc-2.1,2.1-4.4,3.6-7,4.6c-4.4,1.7-8.7,1.9-13.5,2.3h-36.2c0.7-7.3,1.4-14.7,1.7-22.1c0.7-11.6,0.9-23.2,1.1-34.7\n\t\tc0.1-7.8,0.2-15.6,0.3-23.5H227.4z M202.9,1031.8h14.9c4.7-0.3,8.6-0.6,11.5-4.5c0.9-1.3,2.3-3.4,2.3-7c0-1.5-0.1-5.3-3.4-7.8\n\t\tc-3.2-2.5-7.3-2.4-11.6-2.4H204L202.9,1031.8z M204.2,997.8h7.8c6.4-0.1,14.3-0.6,17.1-7c0.2-0.7,0.9-2.3,0.9-4.4\n\t\tc0-0.8-0.2-2.9-1.5-4.8c-2.4-3.3-6-3.4-10-3.6h-13.4L204.2,997.8z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M276,964.8c-0.9,13.6-1.8,27.3-2.5,40.9c-0.7,13.1-1.1,26.1-1.7,39.2h-17.7c1.1-13.8,2.2-27.5,2.9-41.3\n\t\tc0.6-13,0.8-25.9,1.1-39L276,964.8z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M356.7,988.6c-1.1-0.1-2.1-0.3-3.2-0.6c-3.8-0.8-6.8-1.6-10.5-1.6c-2.6,0-7.2,0.6-9.3,2.1\n\t\tc-1.6,1.2-2.2,2.7-2.2,4.6c0,2.3,1.1,4.5,2.1,6.6c8,12.3,10,15.2,19.4,26.5c2.5-6.2,2.8-7.7,3.3-14.5l14,0.1c0,0.6,0,3.6-0.3,5.9\n\t\tc-0.2,2.1-1.4,8.2-4.9,13.5c-1,1.5-1.5,2-3.5,4.5l7.8,9.1h-16.8l-2-2.6c-6,2.6-7.3,3-13.7,3.8H328c-1.9-0.2-8.9-0.8-14.7-4.3\n\t\tc-3-1.7-10.5-7.6-10.5-18.3c0-2.7,0.5-5.1,1.5-7.8c2.7-7.3,8.3-10.6,14.8-14.2c-1.6-3.3-3.2-6.6-3.2-10.1c0-2.7,1.1-8.6,7.5-12.4\n\t\tc5.7-3.4,12.1-3.6,18.6-3.7c8,0.4,9.4,0.8,13.9,1.6L356.7,988.6z M325.3,1011.3c-1,0.5-2.5,1.4-3.4,1.9c-4.5,3.5-5,8.3-5,10.2\n\t\tc0,4.6,2.3,7.4,3.5,8.5c4.2,4.1,9.8,4.1,11.7,4.1c5.3,0,8-1.4,10.5-2.3L325.3,1011.3z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M453.4,964.5c1.9,6,4,11.9,6.2,17.9c3,7.8,6.1,15.6,9.1,23.4c4.9,13.1,9.9,26,14.8,39.1h-19\n\t\tc-2.6-10-3.6-14-10.4-30.5h-30.7c-3.1,5.7-6.3,11.3-9.3,17.2c-2.2,4.4-4.2,8.8-6.2,13.3h-18l42.1-80.4H453.4z M428.7,1001.9h21.6\n\t\tl-9.1-24.9L428.7,1001.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M512.7,976.9c2.5,5.9,5.1,11.9,7.9,17.8c3.2,6.7,6.7,13.4,9.9,20.1c3,6.2,6,12.4,8.9,18.6\n\t\tc0.5-7.9,1-15.7,1.5-23.5c0.5-6.7,1-13.4,1.2-20.1c0.2-4.3,0.3-8.6,0.4-13l13.7,0.1c-1.1,12.5-2.1,25-2.9,37.7\n\t\tc-0.6,10.1-0.9,20.3-1.2,30.5l-22.6-0.1c-2.7-6.1-5.4-12.3-8.3-18.4c-3-6.1-6.2-12.1-9.1-18.3c-3.2-6.7-6.3-13.5-9.4-20.2\n\t\tc-0.6,10-1.2,20-1.8,29.9c-0.3,6-0.7,11.9-0.9,18v9.1l-13.3-0.1c0.8-9.3,1.6-18.7,2.1-28.3c0.3-5.5,0.5-11.1,0.7-16.6\n\t\tc0.3-5.1,0.7-10.2,0.8-15.3v-8L512.7,976.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M609.8,976.8c1.7,5,3.4,10.1,5.2,15.1c2.5,6.6,5.1,13.2,7.7,19.8c4.2,11.1,8.3,22,12.5,33.1h-16.1\n\t\tc-2.2-8.4-3-11.8-8.8-25.8h-26c-2.6,4.9-5.3,9.6-7.9,14.6c-1.8,3.7-3.6,7.5-5.2,11.3h-15.2l35.6-68.1H609.8z M588.8,1008.5H607\n\t\tl-7.7-21.1L588.8,1008.5z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M656.5,977c-0.7,8.6-1.4,17.4-1.8,26.1c-0.5,10-0.9,20.1-1.3,30.2c5.7,0.2,11.5,0.3,17.1,0.1\n\t\tc4.5-0.1,8.9-0.5,13.3-0.9l-0.5,12.3H638c0.5-4.5,1-8.8,1.3-13.3c0.7-9,0.9-18.2,1.3-27.3l0.9-27.4L656.5,977z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M747.8,976.9l-26,38.4c-0.4,7.1-0.9,14.2-1,21.3v8.6l-15.2-0.1c1.6-12.8,1.8-16.6,2.1-29.6l-22.5-38.6\n\t\tl17.4,0.1c1.7,3.9,3.6,7.9,5.6,11.7c2.4,4.7,5,9.1,7.6,13.6c9.6-13.7,11.3-16.9,15.6-25.2H747.8z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M795.9,977c0,2.1,0,4.3-0.1,6.3c-0.1,1.9-0.3,3.8-0.5,5.7c-3.7-0.2-7.3-0.5-11-0.5c-2.4-0.1-4.9,0-7.3,0\n\t\tc-0.6,8.4-1.2,16.9-1.5,25.3c-0.5,10.4-0.8,20.8-1,31.3l-15-0.1c0.7-9.6,1.5-19.3,1.9-29c0.5-9.1,0.8-18.4,1-27.5\n\t\tc-4-0.1-8-0.1-11.8,0.1c-2.1,0.1-4.2,0.3-6.3,0.4l0.6-12.1L795.9,977z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M814.2,977c-0.8,11.6-1.6,23.1-2.1,34.7c-0.6,11.1-1,22.1-1.5,33.2h-15c1-11.7,1.8-23.3,2.4-35\n\t\tc0.5-11,0.7-21.9,1-33L814.2,977z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M875.5,989.6c-7.2-1.6-9.2-2.1-16.5-2.5c-8.4,0.3-15.4,1-20.7,8c-2.1,2.8-5.6,8.8-5.6,17.8\n\t\tc0,9.3,4.4,16.8,13.3,20c2.2,0.8,4.4,1.2,9.1,1.6c8.4,0,10.6-0.4,18.4-2.6l-2.4,13.2c-4.2,0.6-6.1,1-13.6,1.3c-1.5,0-3,0.1-4.6,0.1\n\t\tc-1.9,0-4.2-0.1-8.2-0.6c-5.1-1.2-9.3-2.1-13.7-5.1c-7.7-5.2-10.3-12.6-11.2-15.6c-1.1-3.9-1.4-8.2-1.5-9.3c0-8.3,0.5-9.8,1.5-14.3\n\t\tc1.3-4.1,2.1-6.3,3-8.1c3.5-7,9.8-12.9,17.2-15.6c3.4-1.2,6.2-1.6,9.8-2c8.1-0.4,11.2-0.7,24.9,1.2L875.5,989.6z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M920.7,989.6c-5.5-1.5-11.3-3.1-17.1-3.1c-5,0-7.2,1.3-8.5,3.2c-0.3,0.4-1.1,1.6-1.1,3.1\n\t\tc0,2.6,2.1,4.6,4,6.2c3.6,2.9,7.2,5.8,10.8,8.9c2.8,2.4,5.5,5,8.3,7.5c1.7,1.8,5.7,5.7,5.7,12.6c0,2.6-0.7,8.1-5.9,12.5\n\t\tc-4.5,3.8-9.4,4.6-15.1,5.3c-11.2,0.2-13.9-0.3-24.4-3.3l-0.7-13.1c1.6,0.8,3,1.5,4.7,2.1c7,2.9,13.4,3.3,16.3,3.3\n\t\tc1.8,0,4.3-0.1,5.9-0.8c1-0.3,4.5-1.7,4.5-5.2c0-2.7-2.1-4.7-4.4-6.7c-2.2-1.9-4.5-3.9-6.7-5.7c-2.2-1.8-4.5-3.6-6.6-5.5\n\t\tc-1.5-1.3-2.9-2.7-4.4-4.1c-1.7-1.8-6.5-6.5-6.5-14.2c0-5.1,2.3-10.3,6.8-13.3c1.1-0.7,2.4-1.5,5-2.2c6.5-2,10.3-1.7,13.5-1.7\n\t\tc4.6,0.2,6.9,0.2,14.9,1.9L920.7,989.6z",
                            },
                          }),
                        ]),
                        _c("g", [
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000040553665599899281200000002152790356163330203_",
                                      d: "M504.7,654v50.7c0,11,6.2,21.6,15.4,27.3l30.9,17.6\n\t\t\t\t\t\tl90.4-52.5l-30.9-16.8c-9.7-5.7-15.9-15.9-15.9-27.3v-50.7L504.7,654",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000031890485705033332130000012849661299074191028_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000040553665599899281200000002152790356163330203_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000031890485705033332130000012849661299074191028_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000123406308314138437560000005505704473639121548_",
                                              x: "-217.9",
                                              y: "-38.5",
                                              width: "1599.4",
                                              height: "1065.9",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000088825217709459516490000004454461297843358649_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000123406308314138437560000005505704473639121548_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000088825217709459516490000004454461297843358649_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "502.5",
                                            y: "599.3",
                                            width: "141.5",
                                            height: "152.1",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "SVGID_00000033329436334487012820000014309467057084842175_",
                                      d: "M279,766.9V732h-0.4l-14.1-8.4V758\n\t\t\t\t\t\tc0,7.1,3.5,13.2,8.8,16.8c0.9,0.4,1.8,1.3,2.6,1.8l13.2,7.5C283.4,780.5,279,774.4,279,766.9",
                                    },
                                  }),
                                ]),
                                _c(
                                  "clipPath",
                                  {
                                    attrs: {
                                      id: "SVGID_00000082366744312103323450000003989527800092191924_",
                                    },
                                  },
                                  [
                                    _c("use", {
                                      staticStyle: { overflow: "visible" },
                                      attrs: {
                                        "xlink:href":
                                          "#SVGID_00000033329436334487012820000014309467057084842175_",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "clip-path":
                                        "url(#SVGID_00000082366744312103323450000003989527800092191924_)",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("defs", [
                                          _c("rect", {
                                            attrs: {
                                              id: "SVGID_00000165204525698966130520000014566344776820971173_",
                                              x: "-217.9",
                                              y: "-38.5",
                                              width: "1599.4",
                                              height: "1065.9",
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "clipPath",
                                          {
                                            attrs: {
                                              id: "SVGID_00000163066090936058992340000011593517228210285709_",
                                            },
                                          },
                                          [
                                            _c("use", {
                                              staticStyle: {
                                                overflow: "visible",
                                              },
                                              attrs: {
                                                "xlink:href":
                                                  "#SVGID_00000165204525698966130520000014566344776820971173_",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("rect", {
                                          staticStyle: {
                                            "clip-path":
                                              "url(#SVGID_00000163066090936058992340000011593517228210285709_)",
                                            fill: "#25292A",
                                          },
                                          attrs: {
                                            x: "262.2",
                                            y: "721.5",
                                            width: "29.5",
                                            height: "65.2",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", [
                                _c("g", [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "SVGID_00000052816128783370801240000017949880392934447756_",
                                        d: "M753.3,116.6c-1.8-1.3-3.1-2.2-5.3-3.1\n\t\t\t\t\t\t\tc-3.1-1.3-6.6-1.8-10.1-1.3c-1.8,0-3.5,0.4-4.8,1.3l0,0c-0.9,0.4-1.8,0.9-2.6,1.3l-15.9,8.8l0,0l-421,238.5l14.5,8.4\n\t\t\t\t\t\t\tl436.9-246.9c6.2-3.5,13.7-3.5,19.4-0.4L753.3,116.6",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000006701808604306225400000000339380215168246941_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000052816128783370801240000017949880392934447756_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000006701808604306225400000000339380215168246941_)",
                                      },
                                    },
                                    [
                                      _c("g", [
                                        _c("g", [
                                          _c("defs", [
                                            _c("rect", {
                                              attrs: {
                                                id: "SVGID_00000167360421789892403560000012954109532410438309_",
                                                x: "-217.9",
                                                y: "-38.5",
                                                width: "1599.4",
                                                height: "1065.9",
                                              },
                                            }),
                                          ]),
                                          _c(
                                            "clipPath",
                                            {
                                              attrs: {
                                                id: "SVGID_00000086684917268046648670000000971247924847219338_",
                                              },
                                            },
                                            [
                                              _c("use", {
                                                staticStyle: {
                                                  overflow: "visible",
                                                },
                                                attrs: {
                                                  "xlink:href":
                                                    "#SVGID_00000167360421789892403560000012954109532410438309_",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("rect", {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000086684917268046648670000000971247924847219338_)",
                                              fill: "#25292A",
                                            },
                                            attrs: {
                                              x: "291.3",
                                              y: "110",
                                              width: "475.7",
                                              height: "263.2",
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("g", [
                              _c("g", [
                                _c("g", [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "SVGID_00000009581018465931589130000012416595613483590836_",
                                        d: "M300.1,375c-13.7,7.9-22,22.5-22,37.9l0.9,318.7\n\t\t\t\t\t\t\tl496.4-281.7l0.4-308.6c0-7.5-4-13.7-9.7-17.2l0,0l-1.8-0.9c-5.7-3.1-12.8-3.1-19.4,0.4L308,370.6L300.1,375",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000066508694602286301900000008689411961888641690_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000009581018465931589130000012416595613483590836_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000066508694602286301900000008689411961888641690_)",
                                      },
                                    },
                                    [
                                      _c("g", [
                                        _c("g", [
                                          _c("defs", [
                                            _c("rect", {
                                              attrs: {
                                                id: "SVGID_00000034793692885285104090000014534418252098685071_",
                                                x: "-217.9",
                                                y: "-38.5",
                                                width: "1599.4",
                                                height: "1065.9",
                                              },
                                            }),
                                          ]),
                                          _c(
                                            "clipPath",
                                            {
                                              attrs: {
                                                id: "SVGID_00000000941469941125512790000010630066524459685020_",
                                              },
                                            },
                                            [
                                              _c("use", {
                                                staticStyle: {
                                                  overflow: "visible",
                                                },
                                                attrs: {
                                                  "xlink:href":
                                                    "#SVGID_00000034793692885285104090000014534418252098685071_",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("rect", {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000000941469941125512790000010630066524459685020_)",
                                              fill: "#E0E1DB",
                                            },
                                            attrs: {
                                              x: "275.9",
                                              y: "117.5",
                                              width: "502.1",
                                              height: "616.3",
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("g", [
                              _c("g", [
                                _c("g", [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "SVGID_00000017485267078053744170000010039623776543188646_",
                                        d: "M279,731.6v34.8c0,7.9,4,14.1,10.1,17.6l0.4,0.4l0,0\n\t\t\t\t\t\t\tc5.7,3.1,13.2,3.5,20.3,0l455.4-258.3c6.2-3.5,10.1-10.6,10.1-17.6v-58.2L279,731.6",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000111173736722935849090000001978348851577035189_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000017485267078053744170000010039623776543188646_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000111173736722935849090000001978348851577035189_)",
                                      },
                                    },
                                    [
                                      _c("g", [
                                        _c("g", [
                                          _c("defs", [
                                            _c("rect", {
                                              attrs: {
                                                id: "SVGID_00000029725048761956279760000016073714997578398909_",
                                                x: "-217.9",
                                                y: "-38.5",
                                                width: "1599.4",
                                                height: "1065.9",
                                              },
                                            }),
                                          ]),
                                          _c(
                                            "clipPath",
                                            {
                                              attrs: {
                                                id: "SVGID_00000074442780392135516150000000632588324192853634_",
                                              },
                                            },
                                            [
                                              _c("use", {
                                                staticStyle: {
                                                  overflow: "visible",
                                                },
                                                attrs: {
                                                  "xlink:href":
                                                    "#SVGID_00000029725048761956279760000016073714997578398909_",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("rect", {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000074442780392135516150000000632588324192853634_)",
                                              fill: "#25292A",
                                            },
                                            attrs: {
                                              x: "276.7",
                                              y: "447.7",
                                              width: "501.2",
                                              height: "343",
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("g", [
                              _c("g", [
                                _c("g", [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "SVGID_00000156548659958288267070000017569909819220891316_",
                                        d: "M279,731.6l-0.9-318.7c0-15.9,8.4-30.4,22-37.9\n\t\t\t\t\t\t\tl7.5-4.4l-14.5-8.4l-7.9,4.4c-13.7,7.9-22,22.5-22,37.9l0.9,319.2L279,731.6L279,731.6",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000046323532960145939570000015359289672704477369_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000156548659958288267070000017569909819220891316_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000046323532960145939570000015359289672704477369_)",
                                      },
                                    },
                                    [
                                      _c("g", [
                                        _c("g", [
                                          _c("defs", [
                                            _c("rect", {
                                              attrs: {
                                                id: "SVGID_00000027581039347000492380000017353571559559422099_",
                                                x: "-217.9",
                                                y: "-38.5",
                                                width: "1599.4",
                                                height: "1065.9",
                                              },
                                            }),
                                          ]),
                                          _c(
                                            "clipPath",
                                            {
                                              attrs: {
                                                id: "SVGID_00000063597875921812547600000016599095608252790436_",
                                              },
                                            },
                                            [
                                              _c("use", {
                                                staticStyle: {
                                                  overflow: "visible",
                                                },
                                                attrs: {
                                                  "xlink:href":
                                                    "#SVGID_00000027581039347000492380000017353571559559422099_",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("rect", {
                                            staticStyle: {
                                              "clip-path":
                                                "url(#SVGID_00000063597875921812547600000016599095608252790436_)",
                                              fill: "#25292A",
                                            },
                                            attrs: {
                                              x: "261.3",
                                              y: "359.5",
                                              width: "48.9",
                                              height: "374.7",
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "_x31__00000049221338407463378080000016849216479500971187_",
                                },
                              },
                              [
                                _c("g", [
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st737",
                                      attrs: {
                                        d: "M523.9,314.5c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4\n\t\t\t\t\t\tc-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6\n\t\t\t\t\t\tc0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6\n\t\t\t\t\t\tl-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-49.7,28.7l-8.1,4.7v-4.6v-37.5l5.2-3\n\t\t\t\t\t\tc0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-5.2,3v-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-5.2,3\n\t\t\t\t\t\tv-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-5.2,3v-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3\n\t\t\t\t\t\tc0-0.5-0.4-0.6-0.9-0.4l-5.2,3v-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-11.8,6.8c-0.5,0.3-0.9,0.9-0.9,1.3\n\t\t\t\t\t\tc0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v42.1l-4.9,2.9c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v42.1l-4.9,2.9\n\t\t\t\t\t\tc-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v42.1l-4.9,2.9c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4\n\t\t\t\t\t\tl4.9-2.9v42.1l-4.9,2.9c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v37.5v5.5c0,0.5,0.4,0.6,0.9,0.4l8.9-5.2\n\t\t\t\t\t\tl49.7-28.7v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4\n\t\t\t\t\t\tc0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9\n\t\t\t\t\t\tc0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9\n\t\t\t\t\t\tl57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-11.2C524.8,314.3,524.4,314.2,523.9,314.5z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M152.8,538.8c0,0.5-0.1,1-0.3,1.5c-0.2,0.4-0.4,0.9-0.7,1.3c-0.3,0.5-0.8,0.9-1.4,1.2\n\t\t\t\t\t\t\t\t\tc-0.6,0.3-1.1,0.5-1.4,0.4c-0.3-0.1-0.6-0.2-0.7-0.5c-0.2-0.3-0.3-0.7-0.3-1.2v-7.2c0-0.5,0.1-1,0.3-1.5\n\t\t\t\t\t\t\t\t\tc0.2-0.4,0.4-0.9,0.7-1.3c0.3-0.4,0.8-0.9,1.4-1.2c0.6-0.3,1.1-0.4,1.4-0.4c0.3,0.1,0.6,0.3,0.7,0.5\n\t\t\t\t\t\t\t\t\tc0.2,0.3,0.3,0.7,0.3,1.1V538.8z M151,532.6c0-0.3-0.1-0.5-0.2-0.6c-0.1,0-0.2,0-0.4,0.1c-0.3,0.2-0.5,0.5-0.5,0.8\n\t\t\t\t\t\t\t\t\tc-0.1,0.2-0.1,0.3-0.1,0.5v7.2c0,0.4,0.1,0.5,0.3,0.6c0.1,0,0.2,0,0.4-0.1c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.1,0.1-0.3,0.1-0.5\n\t\t\t\t\t\t\t\t\tV532.6z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M151.1,492.7c0-0.5-0.2-0.8-0.6-0.6c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,0.7l-1.5,0.9\n\t\t\t\t\t\t\t\t\tv-6.5l4.4-2.5v1.8l-2.8,1.6v2.6c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.3-0.2,0.4-0.3c0.9-0.5,1.4-0.3,1.7,0.1\n\t\t\t\t\t\t\t\t\tc0.3,0.4,0.3,1,0.3,1.2v2.7c0,0.6,0,1.4-0.4,2.2c-0.3,0.9-0.9,1.7-2,2.3c-1.1,0.6-1.7,0.5-2-0.1c-0.3-0.5-0.4-1.4-0.4-2.3\n\t\t\t\t\t\t\t\t\tl1.8-1v0.5c0,0.6,0,1,0.1,1.2c0.1,0.2,0.2,0.2,0.4,0.1c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.3,0.1-0.7,0.1-1.4V492.7z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M143.7,449.3v-1.2c0.8-0.6,1.2-1.2,1.5-1.7c0.2-0.3,0.3-0.6,0.4-0.9l1.1-0.6v12.3l-1.8,1v-9.6\n\t\t\t\t\t\t\t\t\tL143.7,449.3z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M152.8,451.2c0,0.5-0.1,1-0.3,1.5c-0.2,0.4-0.4,0.9-0.7,1.3c-0.3,0.5-0.8,0.9-1.4,1.2\n\t\t\t\t\t\t\t\t\tc-0.6,0.3-1.1,0.5-1.4,0.4c-0.3-0.1-0.6-0.2-0.7-0.5c-0.2-0.3-0.3-0.7-0.3-1.2v-7.2c0-0.5,0.1-1,0.3-1.5\n\t\t\t\t\t\t\t\t\tc0.2-0.4,0.4-0.9,0.7-1.3c0.3-0.4,0.8-0.9,1.4-1.2c0.6-0.3,1.1-0.4,1.4-0.4c0.3,0.1,0.6,0.3,0.7,0.5\n\t\t\t\t\t\t\t\t\tc0.2,0.3,0.3,0.7,0.3,1.1V451.2z M151,445c0-0.3-0.1-0.5-0.2-0.6c-0.1,0-0.2,0-0.4,0.1c-0.3,0.2-0.5,0.5-0.5,0.8\n\t\t\t\t\t\t\t\t\tc-0.1,0.2-0.1,0.3-0.1,0.5v7.2c0,0.4,0.1,0.5,0.3,0.6c0.1,0,0.2,0,0.4-0.1c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.1,0.1-0.3,0.1-0.5\n\t\t\t\t\t\t\t\t\tV445z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M143.9,405.4v-1.2c0.8-0.6,1.2-1.2,1.5-1.7c0.2-0.3,0.3-0.6,0.4-0.9l1.1-0.6v12.3l-1.8,1v-9.6\n\t\t\t\t\t\t\t\t\tL143.9,405.4z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M151.1,405.1c0-0.5-0.2-0.8-0.6-0.6c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,0.7l-1.5,0.9\n\t\t\t\t\t\t\t\t\tv-6.5l4.4-2.5v1.8l-2.8,1.6v2.6c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.3-0.2,0.4-0.3c0.9-0.5,1.4-0.3,1.7,0.1\n\t\t\t\t\t\t\t\t\tc0.3,0.4,0.3,1,0.3,1.2v2.7c0,0.6,0,1.4-0.4,2.2c-0.3,0.9-0.9,1.7-2,2.3c-1.1,0.6-1.7,0.5-2-0.1c-0.3-0.5-0.4-1.4-0.4-2.3\n\t\t\t\t\t\t\t\t\tl1.8-1v0.5c0,0.6,0,1,0.1,1.2c0.1,0.2,0.2,0.2,0.4,0.1c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.3,0.1-0.7,0.1-1.4V405.1z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M141.9,364v-0.9c0-0.8,0.1-1.7,0.5-2.5c0.3-0.8,1-1.5,1.9-2.1c0.9-0.5,1.5-0.5,1.9-0.2\n\t\t\t\t\t\t\t\t\tc0.4,0.3,0.5,1,0.5,1.9c0,1.3-0.5,3-1.1,4.7c-0.6,1.8-1.3,3.4-1.8,4.5l2.9-1.6v1.8l-4.9,2.8v-1.8c0.6-1.2,1.1-2.3,1.5-3.5\n\t\t\t\t\t\t\t\t\tc0.4-1,0.8-2,1-3c0.3-1,0.5-2,0.5-2.7c0-0.3,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.5-0.2c-0.2,0.1-0.4,0.4-0.5,0.7\n\t\t\t\t\t\t\t\t\tc-0.1,0.3-0.1,0.7-0.1,1.1v0.9L141.9,364z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M152.8,363.6c0,0.5-0.1,1-0.3,1.5c-0.2,0.4-0.4,0.9-0.7,1.3c-0.3,0.5-0.8,0.9-1.4,1.2\n\t\t\t\t\t\t\t\t\tc-0.6,0.3-1.1,0.5-1.4,0.4c-0.3-0.1-0.6-0.2-0.7-0.5c-0.2-0.3-0.3-0.7-0.3-1.2v-7.2c0-0.5,0.1-1,0.3-1.5\n\t\t\t\t\t\t\t\t\tc0.2-0.4,0.4-0.9,0.7-1.3c0.3-0.4,0.8-0.9,1.4-1.2c0.6-0.3,1.1-0.4,1.4-0.4c0.3,0.1,0.6,0.3,0.7,0.5\n\t\t\t\t\t\t\t\t\tc0.2,0.3,0.3,0.7,0.3,1.1V363.6z M151,357.4c0-0.3-0.1-0.5-0.2-0.6c-0.1,0-0.2,0-0.4,0.1c-0.3,0.2-0.5,0.5-0.5,0.8\n\t\t\t\t\t\t\t\t\tc-0.1,0.2-0.1,0.3-0.1,0.5v7.2c0,0.4,0.1,0.5,0.3,0.6c0.1,0,0.2,0,0.4-0.1c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.1,0.1-0.3,0.1-0.5\n\t\t\t\t\t\t\t\t\tV357.4z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M142.1,320.1v-0.9c0-0.8,0.1-1.7,0.5-2.5c0.4-0.8,1-1.5,1.9-2.1c0.9-0.5,1.5-0.5,1.9-0.2\n\t\t\t\t\t\t\t\t\tc0.4,0.3,0.5,1,0.5,1.9c0,1.3-0.5,3-1.1,4.7c-0.6,1.8-1.3,3.4-1.8,4.5l2.9-1.6v1.8l-4.9,2.8v-1.8c0.6-1.2,1.1-2.3,1.5-3.5\n\t\t\t\t\t\t\t\t\tc0.4-1,0.8-2,1-3c0.3-1,0.5-2,0.5-2.7c0-0.3,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.5-0.2c-0.2,0.1-0.4,0.4-0.5,0.7\n\t\t\t\t\t\t\t\t\tc-0.1,0.3-0.1,0.7-0.1,1.1v0.9L142.1,320.1z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M151.1,317.5c0-0.5-0.2-0.8-0.6-0.6c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,0.7l-1.5,0.9\n\t\t\t\t\t\t\t\t\tv-6.5l4.4-2.5v1.8l-2.8,1.6v2.6c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.3-0.2,0.4-0.3c0.9-0.5,1.4-0.3,1.7,0.1\n\t\t\t\t\t\t\t\t\tc0.3,0.4,0.3,1,0.3,1.2v2.7c0,0.6,0,1.4-0.4,2.2c-0.3,0.9-0.9,1.7-2,2.3c-1.1,0.6-1.7,0.5-2-0.1c-0.3-0.5-0.4-1.4-0.4-2.3\n\t\t\t\t\t\t\t\t\tl1.8-1v0.5c0,0.6,0,1,0.1,1.2c0.1,0.2,0.2,0.2,0.4,0.1c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.3,0.1-0.7,0.1-1.4V317.5z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]),
                                    _c("g", { staticClass: "st746" }, [
                                      _c("g", [
                                        _c("g", [
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st771",
                                              attrs: {
                                                d: "M196.7,501.8c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-0.6-0.4-0.4-0.9l59.5-157c0.2-0.5,0.7-1,1.1-1.1\n\t\t\t\t\t\t\t\t\t\tc0.4,0,0.6,0.4,0.4,0.9l-59.5,157C197.3,501.3,197,501.6,196.7,501.8z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st771",
                                              attrs: {
                                                d: "M315.7,415.6c-0.3,0.2-0.6,0.2-0.7,0l-59.5-70.7c-0.2-0.3-0.1-0.9,0.3-1.3c0.4-0.5,0.9-0.6,1.2-0.3\n\t\t\t\t\t\t\t\t\t\tl59.5,70.7c0.2,0.3,0.1,0.9-0.3,1.3C316,415.4,315.8,415.5,315.7,415.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st771",
                                              attrs: {
                                                d: "M315.7,415.6c-0.3,0.2-0.6,0.2-0.7,0c-0.2-0.3-0.1-0.9,0.3-1.3l59.5-69.4c0.4-0.5,0.9-0.6,1.2-0.4\n\t\t\t\t\t\t\t\t\t\tc0.2,0.3,0.1,0.9-0.3,1.3l-59.5,69.4C316,415.4,315.8,415.5,315.7,415.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st771",
                                              attrs: {
                                                d: "M375.2,346.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-0.6-0.4-0.3-1l59.5-139.4c0.2-0.5,0.8-1,1.2-1\n\t\t\t\t\t\t\t\t\t\tc0.4,0,0.6,0.4,0.3,1l-59.5,139.4C375.7,345.7,375.5,346,375.2,346.2z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st771",
                                              attrs: {
                                                d: "M434.7,206.7c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-86.9c0.4-0.5,0.9-0.8,1.2-0.6\n\t\t\t\t\t\t\t\t\t\tc0.3,0.2,0.3,0.7-0.1,1.2l-59.5,86.9C435.1,206.4,434.9,206.6,434.7,206.7z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st404",
                                              attrs: {
                                                d: "M196.7,475.5c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-86.9c0.4-0.5,0.9-0.8,1.2-0.6\n\t\t\t\t\t\t\t\t\t\tc0.3,0.2,0.3,0.7-0.1,1.2L197.2,475C197.1,475.2,196.9,475.4,196.7,475.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st404",
                                              attrs: {
                                                d: "M256.2,388.6c-0.2,0.1-0.3,0.1-0.5,0.1c-0.4,0-0.5-0.5-0.2-1.1L315,265.8c0.3-0.5,0.8-0.9,1.2-0.9\n\t\t\t\t\t\t\t\t\t\tc0.4,0,0.5,0.5,0.2,1.1l-59.5,121.9C256.7,388.2,256.4,388.5,256.2,388.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st404",
                                              attrs: {
                                                d: "M375.2,293.6c-0.2,0.1-0.4,0.2-0.6,0.1l-59.5-27c-0.3-0.1-0.3-0.7,0-1.2c0.3-0.5,0.9-0.8,1.2-0.7\n\t\t\t\t\t\t\t\t\t\tl59.5,27c0.3,0.1,0.3,0.7,0,1.2C375.6,293.3,375.4,293.5,375.2,293.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st404",
                                              attrs: {
                                                d: "M434.7,276.8c-0.1,0-0.2,0.1-0.2,0.1l-59.5,16.8c-0.5,0.1-0.7-0.2-0.6-0.7c0.1-0.5,0.6-1.1,1.1-1.2\n\t\t\t\t\t\t\t\t\t\tl59.5-16.8c0.5-0.1,0.7,0.2,0.6,0.7C435.4,276.2,435,276.6,434.7,276.8z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st404",
                                              attrs: {
                                                d: "M494.2,312.5c-0.2,0.1-0.5,0.2-0.6,0.1L434,276.9c-0.3-0.2-0.3-0.7,0.1-1.3c0.4-0.5,0.9-0.8,1.2-0.6\n\t\t\t\t\t\t\t\t\t\tl59.5,35.7c0.3,0.2,0.3,0.7-0.1,1.3C494.5,312.2,494.4,312.4,494.2,312.5z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st772",
                                              attrs: {
                                                d: "M196.7,459.6c-0.4,0.2-0.7,0.2-0.8-0.1c-0.1-0.4,0.1-1,0.5-1.4l59.5-53.4c0.5-0.4,0.9-0.4,1.1-0.1\n\t\t\t\t\t\t\t\t\t\tc0.1,0.4-0.1,1-0.5,1.4l-59.5,53.4C196.9,459.5,196.8,459.5,196.7,459.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st772",
                                              attrs: {
                                                d: "M256.2,406.1c-0.2,0.1-0.4,0.2-0.6,0.1c-0.4-0.1-0.4-0.6-0.1-1.1L315,300.7c0.3-0.5,0.8-0.9,1.2-0.8\n\t\t\t\t\t\t\t\t\t\tc0.4,0.1,0.4,0.6,0.1,1.1l-59.5,104.4C256.7,405.8,256.4,406,256.2,406.1z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st772",
                                              attrs: {
                                                d: "M315.7,301.7c-0.2,0.1-0.4,0.2-0.6,0.1c-0.4-0.1-0.4-0.6-0.1-1.1l59.5-104.4\n\t\t\t\t\t\t\t\t\t\tc0.3-0.5,0.8-0.9,1.2-0.8c0.4,0.1,0.4,0.6,0.1,1.1L316.3,301C316.2,301.3,315.9,301.6,315.7,301.7z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st772",
                                              attrs: {
                                                d: "M434.7,338.1c-0.4,0.2-0.7,0.2-0.8-0.1l-59.5-140.8c-0.2-0.4,0.1-1,0.5-1.4c0.4-0.4,0.9-0.5,1.1-0.1\n\t\t\t\t\t\t\t\t\t\tl59.5,140.8c0.2,0.4-0.1,1-0.5,1.4C434.8,338,434.8,338.1,434.7,338.1z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st772",
                                              attrs: {
                                                d: "M494.2,330c-0.1,0.1-0.2,0.1-0.3,0.1l-59.5,8.1c-0.4,0.1-0.6-0.3-0.4-0.9c0.2-0.5,0.7-1,1.1-1.1\n\t\t\t\t\t\t\t\t\t\tl59.5-8.1c0.4-0.1,0.6,0.3,0.4,0.9C494.8,329.5,494.5,329.9,494.2,330z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st737",
                                              attrs: {
                                                d: "M196.7,440.5c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-0.6-0.4-0.4-0.9l59.5-148.2c0.2-0.5,0.7-1,1.2-1\n\t\t\t\t\t\t\t\t\t\tc0.4,0,0.6,0.4,0.4,0.9l-59.5,148.2C197.3,440,197,440.3,196.7,440.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st737",
                                              attrs: {
                                                d: "M315.7,310.5c-0.2,0.1-0.4,0.2-0.6,0.1l-59.5-18.2c-0.4-0.1-0.4-0.6-0.1-1.2\n\t\t\t\t\t\t\t\t\t\tc0.3-0.5,0.9-0.9,1.2-0.8l59.5,18.2c0.4,0.1,0.4,0.6,0.1,1.2C316.1,310.1,315.9,310.3,315.7,310.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st737",
                                              attrs: {
                                                d: "M375.2,321.2c-0.2,0.1-0.4,0.2-0.5,0.1l-62.5-11.8c-0.4-0.1-0.4-0.6-0.2-1.1\n\t\t\t\t\t\t\t\t\t\tc0.3-0.5,0.8-0.9,1.2-0.8l62.5,11.8c0.4,0.1,0.4,0.6,0.2,1.1C375.7,320.8,375.4,321.1,375.2,321.2z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st737",
                                              attrs: {
                                                d: "M375.2,321.2c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-88.2c0.4-0.5,0.9-0.8,1.2-0.6\n\t\t\t\t\t\t\t\t\t\tc0.3,0.2,0.3,0.7-0.1,1.2l-59.5,88.2C375.6,320.9,375.4,321.1,375.2,321.2z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st737",
                                              attrs: {
                                                d: "M434.7,233c-0.3,0.2-0.6,0.2-0.8,0c-0.2-0.3,0-0.9,0.4-1.4l59.5-63.4c0.4-0.4,0.9-0.6,1.1-0.3\n\t\t\t\t\t\t\t\t\t\tc0.2,0.3,0,0.9-0.4,1.4L435,232.7C434.9,232.8,434.8,233,434.7,233z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M256.2,458.7c-0.2,0.1-0.5,0.2-0.6,0.1L196,423c-0.3-0.2-0.3-0.7,0.1-1.3c0.4-0.5,0.9-0.8,1.2-0.6\n\t\t\t\t\t\t\t\t\t\tl59.5,35.7c0.3,0.2,0.3,0.7-0.1,1.3C256.6,458.4,256.4,458.6,256.2,458.7z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M256.2,458.7c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-86.9c0.4-0.5,0.9-0.8,1.2-0.6\n\t\t\t\t\t\t\t\t\t\tc0.3,0.2,0.3,0.7-0.1,1.2l-59.5,86.9C256.6,458.4,256.4,458.6,256.2,458.7z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M375.2,372.5c-0.1,0.1-0.3,0.1-0.4,0.1l-59.5-0.7c-0.4,0-0.5-0.4-0.3-1c0.2-0.5,0.8-1,1.2-1\n\t\t\t\t\t\t\t\t\t\tl59.5,0.7c0.4,0,0.5,0.4,0.3,1C375.7,372,375.5,372.3,375.2,372.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M375.2,372.5c-0.2,0.1-0.4,0.2-0.6,0.1c-0.3-0.1-0.3-0.7,0-1.2l82.9-133.7c0.3-0.5,0.9-0.8,1.2-0.7\n\t\t\t\t\t\t\t\t\t\tc0.3,0.1,0.3,0.7,0,1.2l-82.9,133.7C375.6,372.1,375.4,372.3,375.2,372.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M458.2,237.8c-0.1,0.1-0.2,0.1-0.3,0.1c-0.4,0.1-0.7-0.3-0.5-0.8l35.9-117.9c0.2-0.5,0.7-1,1.1-1.1\n\t\t\t\t\t\t\t\t\t\tc0.4-0.1,0.7,0.3,0.5,0.8L459,236.8C458.9,237.2,458.6,237.6,458.2,237.8z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st771",
                                            attrs: {
                                              d: "M196.7,495.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC191.6,501.1,193.9,497.5,196.7,495.8z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st771",
                                            attrs: {
                                              d: "M256.2,338.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC251.1,344.1,253.4,340.5,256.2,338.9z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st771",
                                            attrs: {
                                              d: "M315.7,409.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC310.6,414.9,312.8,411.2,315.7,409.6z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st771",
                                            attrs: {
                                              d: "M375.2,340.2c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC370.1,345.5,372.3,341.9,375.2,340.2z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st771",
                                            attrs: {
                                              d: "M434.7,200.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC429.6,206,431.8,202.4,434.7,200.8z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st771",
                                            attrs: {
                                              d: "M494.2,113.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC489,119.1,491.3,115.5,494.2,113.9z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st404",
                                            attrs: {
                                              d: "M196.7,469.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1s-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC191.6,474.8,193.9,471.2,196.7,469.6z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st404",
                                            attrs: {
                                              d: "M256.2,382.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC251.1,387.9,253.4,384.3,256.2,382.7z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st404",
                                            attrs: {
                                              d: "M315.7,260.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC310.6,266,312.8,262.4,315.7,260.7z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st404",
                                            attrs: {
                                              d: "M375.2,287.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC370.1,292.9,372.3,289.3,375.2,287.7z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st404",
                                            attrs: {
                                              d: "M434.7,270.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC429.6,276.1,431.8,272.5,434.7,270.9z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st404",
                                            attrs: {
                                              d: "M494.2,306.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC489,311.8,491.3,308.2,494.2,306.6z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st772",
                                            attrs: {
                                              d: "M196.7,452.4c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1s-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC191.6,457.7,193.9,454,196.7,452.4z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st772",
                                            attrs: {
                                              d: "M256.2,400.2c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC251.1,405.4,253.4,401.8,256.2,400.2z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st772",
                                            attrs: {
                                              d: "M375.2,191.3c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC370.1,196.6,372.3,193,375.2,191.3z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st772",
                                            attrs: {
                                              d: "M434.7,332.2c2.8-1.6,5.1-0.7,5.1,2.2s-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC429.6,337.4,431.8,333.8,434.7,332.2z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st772",
                                            attrs: {
                                              d: "M494.2,324.1c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC489,329.3,491.3,325.7,494.2,324.1z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M196.7,434.5c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1s-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC191.6,439.8,193.9,436.2,196.7,434.5z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M256.2,286.3c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC251.1,291.6,253.4,287.9,256.2,286.3z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M312,303.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC306.9,309,309.2,305.4,312,303.8z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M375.2,314c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC370.1,319.2,372.3,315.6,375.2,314z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M434.7,227.1c2.8-1.6,5.1-0.7,5.1,2.2s-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC429.6,232.3,431.8,228.7,434.7,227.1z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st737",
                                            attrs: {
                                              d: "M494.2,163.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tS491.3,165.2,494.2,163.6z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("g", [
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st702",
                                            attrs: {
                                              d: "M196.7,417c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC191.6,422.2,193.9,418.6,196.7,417z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st702",
                                            attrs: {
                                              d: "M256.2,452.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC251.1,458,253.4,454.4,256.2,452.7z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st702",
                                            attrs: {
                                              d: "M315.7,365.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tS312.8,367.5,315.7,365.8z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st702",
                                            attrs: {
                                              d: "M375.2,366.5c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC370.1,371.7,372.3,368.1,375.2,366.5z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st702",
                                            attrs: {
                                              d: "M457.7,231.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tS454.8,233.3,457.7,231.6z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st702",
                                            attrs: {
                                              d: "M494.2,113.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2\n\t\t\t\t\t\t\t\t\tC489,119.1,491.3,115.5,494.2,113.9z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "_x31__00000154392146280744819330000000890916025893239190_",
                                    },
                                  },
                                  [
                                    _c("g", [
                                      _c("g", [
                                        _c("g", [
                                          _c("polygon", {
                                            staticClass: "st697",
                                            attrs: {
                                              points:
                                                "841.3,485.8 353.6,767.4 353.5,439.8 841.2,158.2 \t\t\t\t\t\t\t",
                                            },
                                          }),
                                          _c("polygon", {
                                            staticClass: "st702",
                                            attrs: {
                                              points:
                                                "841.2,174.8 353.5,456.4 353.5,417 841.2,135.4 \t\t\t\t\t\t\t",
                                            },
                                          }),
                                        ]),
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st773",
                                            attrs: {
                                              d: "M387.2,725.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6V594.7c0-1.4,1.1-3.1,2.5-3.9l421-243.1\n\t\t\t\t\t\t\t\tc0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v128.7c0,1.4-1.1,3.1-2.5,3.9l-421,243.1\n\t\t\t\t\t\t\t\tC388.1,725.1,387.6,725.3,387.2,725.3z M810.3,348.5c-0.2,0-0.5,0.1-0.8,0.3l-421,243.1c-1,0.6-1.9,1.9-1.9,2.9v128.7\n\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l421-243.1c1-0.6,1.9-1.9,1.9-2.9V349.1c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\tC810.5,348.5,810.4,348.5,810.3,348.5z",
                                            },
                                          }),
                                        ]),
                                        _c("path", {
                                          staticClass: "st774",
                                          attrs: {
                                            d: "M754.9,261.5c-8.1-1.4-16.3,0.6-25.7,5.9c-0.9,0.5-1.9,1.1-2.9,1.7c-10.6,6.7-19.4,15.7-27.6,28.1\n\t\t\t\t\t\t\tc-8.2,12.4-13.3,24.5-16,37.8c-6.8,33.3,8.5,54.7,34,47.8c4.3-1.2,8.6-3,12.8-5.4c15.8-9.1,30.6-26.7,39.6-48\n\t\t\t\t\t\t\tC783.5,295.6,777.1,265.2,754.9,261.5z M754.1,326.9c-1.1,2.6-2.4,5.2-3.9,7.9c-5.8,10.1-13.4,17.8-21.1,22.2\n\t\t\t\t\t\t\tc-2.6,1.5-5.2,2.6-7.8,3.3c-4.9,1.3-9.5,1-13.4-1.2c-7.9-4.5-10.5-15.7-7.8-28.7c1.3-6.4,3.8-13.2,7.7-19.9\n\t\t\t\t\t\t\tc0.7-1.3,1.5-2.5,2.3-3.7c5-7.6,11.1-13.6,17.2-17.6c0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.8\n\t\t\t\t\t\t\tc1.7,0.3,3.4,0.9,4.9,1.7C760.3,292,761.6,309.2,754.1,326.9z",
                                          },
                                        }),
                                        _c("g", [
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M387.2,488c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9l82.2-47.4\n\t\t\t\t\t\t\t\t\tc0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4C388.1,487.9,387.6,488,387.2,488z\n\t\t\t\t\t\t\t\t\t M471.5,409.2c-0.2,0-0.4,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2\n\t\t\t\t\t\t\t\t\tl82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6C471.7,409.3,471.6,409.2,471.5,409.2z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M485.4,431.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9\n\t\t\t\t\t\t\t\t\tl82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4\n\t\t\t\t\t\t\t\t\tC486.3,431.2,485.8,431.3,485.4,431.3z M569.7,352.5c-0.2,0-0.5,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3\n\t\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\t\tC569.9,352.5,569.8,352.5,569.7,352.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M387.2,532.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9\n\t\t\t\t\t\t\t\t\tl82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4\n\t\t\t\t\t\t\t\t\tC388.1,532.1,387.6,532.3,387.2,532.3z M471.5,453.5c-0.2,0-0.4,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3\n\t\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\t\tC471.7,453.5,471.6,453.5,471.5,453.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M485.4,475.5c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9\n\t\t\t\t\t\t\t\t\tl82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4\n\t\t\t\t\t\t\t\t\tC486.3,475.4,485.8,475.5,485.4,475.5z M569.7,396.8c-0.2,0-0.5,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3\n\t\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\t\tC569.9,396.8,569.8,396.8,569.7,396.8z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M387.2,576.1c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9\n\t\t\t\t\t\t\t\t\tl82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4\n\t\t\t\t\t\t\t\t\tC388.1,576,387.6,576.1,387.2,576.1z M471.5,497.3c-0.2,0-0.5,0.1-0.8,0.3L388.6,545c-1,0.6-1.9,1.9-1.9,2.9v26.3\n\t\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9V498c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\t\tC471.7,497.4,471.6,497.3,471.5,497.3z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M485.4,519.4c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9\n\t\t\t\t\t\t\t\t\tl82.2-47.4c0.8-0.5,1.6-0.6,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L486.8,519\n\t\t\t\t\t\t\t\t\tC486.3,519.3,485.8,519.4,485.4,519.4z M569.7,440.6c-0.2,0-0.5,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3\n\t\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\t\tC569.9,440.7,569.8,440.6,569.7,440.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M582.6,375.1c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6V347c0-1.4,1.1-3.1,2.5-3.9l82.2-47.4\n\t\t\t\t\t\t\t\t\tc0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L584,374.7C583.6,375,583.1,375.1,582.6,375.1\n\t\t\t\t\t\t\t\t\tz M667,296.4c-0.2,0-0.4,0.1-0.8,0.3L584,344.1c-1,0.6-1.9,1.9-1.9,2.9v26.3c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2\n\t\t\t\t\t\t\t\t\tl82.2-47.4c1-0.6,1.9-1.9,1.9-2.9V297c0-0.2,0-0.5-0.2-0.6C667.2,296.4,667.1,296.4,667,296.4z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M582.6,419.4c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9\n\t\t\t\t\t\t\t\t\tl82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L584,419\n\t\t\t\t\t\t\t\t\tC583.6,419.3,583.1,419.4,582.6,419.4z M667,340.6c-0.2,0-0.4,0.1-0.8,0.3L584,388.3c-1,0.6-1.9,1.9-1.9,2.9v26.3\n\t\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\t\tC667.2,340.7,667.1,340.6,667,340.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M582.6,463.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9\n\t\t\t\t\t\t\t\t\tl82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L584,462.9\n\t\t\t\t\t\t\t\t\tC583.6,463.1,583.1,463.3,582.6,463.3z M667,384.5c-0.2,0-0.4,0.1-0.8,0.3L584,432.2c-1,0.6-1.9,1.9-1.9,2.9v26.3\n\t\t\t\t\t\t\t\t\tc0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6\n\t\t\t\t\t\t\t\t\tC667.2,384.5,667.1,384.5,667,384.5z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "405.2,459.9 395,465.8 395,461.2 405.2,455.3 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "434.8,442.8 409.6,457.3 409.6,452.8 434.8,438.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "449.1,434.6 439.2,440.3 439.2,435.7 449.1,430 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "416.2,462.1 395,474.3 395,469.7 416.2,457.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "427.1,455.8 420.6,459.5 420.6,454.9 427.1,451.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "442.8,446.7 431.6,453.2 431.6,448.6 442.8,442.1 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "502.9,403.5 492.7,409.4 492.7,404.8 502.9,398.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "519.6,393.9 507.4,400.9 507.4,396.3 519.6,389.3 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "533.6,385.8 524,391.3 524,386.7 533.6,381.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "513.9,405.7 492.7,417.9 492.7,413.3 513.9,401.1 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "529.8,396.5 518.3,403.1 518.3,398.5 529.8,391.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "600.1,347.3 589.9,353.2 589.9,348.6 600.1,342.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "629.7,330.3 604.6,344.8 604.6,340.2 629.7,325.7 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "611.1,349.5 589.9,361.8 589.9,357.2 611.1,344.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "622.1,343.2 615.6,347 615.6,342.4 622.1,338.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "404.4,504.7 394.2,510.5 394.2,505.9 404.4,500.1 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "434,487.6 408.8,502.1 408.8,497.5 434,483 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "415.4,506.8 394.2,519.1 394.2,514.5 415.4,502.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "426.3,500.5 419.8,504.3 419.8,499.7 426.3,495.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "502.9,447.8 492.7,453.6 492.7,449.1 502.9,443.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "519.6,438.1 507.4,445.2 507.4,440.6 519.6,433.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "533.6,430 524,435.6 524,431 533.6,425.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "513.9,449.9 492.7,462.2 492.7,457.6 513.9,445.3 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "529.8,440.8 518.3,447.4 518.3,442.8 529.8,436.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "600.1,391.6 589.9,397.5 589.9,392.9 600.1,387 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "629.7,374.5 604.6,389.1 604.6,384.5 629.7,369.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "611.1,393.8 589.9,406 589.9,401.4 611.1,389.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "622.1,387.5 615.6,391.2 615.6,386.6 622.1,382.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "403.8,548.8 393.6,554.7 393.6,550.1 403.8,544.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "423.6,537.4 408.3,546.2 408.3,541.6 423.6,532.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "419,548.6 393.6,563.2 393.6,558.6 419,544 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "502.9,491.6 492.7,497.5 492.7,492.9 502.9,487 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "519.6,482 507.4,489 507.4,484.4 519.6,477.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "533.6,473.9 524,479.4 524,474.8 533.6,469.3 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "513.9,493.8 492.7,506 492.7,501.4 513.9,489.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "600.1,435.5 589.9,441.3 589.9,436.7 600.1,430.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "629.7,418.4 604.6,432.9 604.6,428.3 629.7,413.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "611.1,437.6 589.9,449.9 589.9,445.3 611.1,433 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "622.1,431.3 615.6,435.1 615.6,430.5 622.1,426.7 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                        ]),
                                        _c("path", {
                                          staticClass: "st773",
                                          attrs: {
                                            d: "M809.3,348.2l-421,243.1c-1.2,0.7-2.2,2.2-2.2,3.4v20.3l425.3-245.6v-20.3\n\t\t\t\t\t\t\tC811.4,347.9,810.5,347.5,809.3,348.2z",
                                          },
                                        }),
                                        _c("g", [
                                          _c("g", [
                                            _c("g", { staticClass: "st417" }, [
                                              _c("path", {
                                                staticClass: "st775",
                                                attrs: {
                                                  d: "M746.8,339.4c-2.8,2.6-5.7,4.7-8.6,6.4c-2.6,1.5-5.2,2.6-7.8,3.3c-4.9,1.3-9.5,1-13.4-1.2l5.5,3.2\n\t\t\t\t\t\t\t\t\t\tc3.9,2.2,8.5,2.5,13.4,1.2c2.5-0.7,5.2-1.8,7.8-3.3c2.5-1.4,4.9-3.2,7.3-5.3L746.8,339.4z",
                                                },
                                              }),
                                              _c("path", {
                                                staticClass: "st775",
                                                attrs: {
                                                  d: "M738.2,262c-1.3-1.1-2.5-2.2-3.8-3.3c-10.1,6.7-18.6,15.4-26.6,27.4c-8.2,12.4-13.3,24.5-16,37.8\n\t\t\t\t\t\t\t\t\t\tc-4.5,22.2,0.8,39.1,12.4,45.9l5.5,3.2c-11.6-6.7-16.9-23.7-12.4-45.9c2.7-13.3,7.8-25.4,16-37.8\n\t\t\t\t\t\t\t\t\t\tc7.7-11.6,15.9-20.2,25.6-26.7C738.8,262.4,738.5,262.2,738.2,262z",
                                                },
                                              }),
                                              _c("path", {
                                                staticClass: "st750",
                                                attrs: {
                                                  d: "M769.6,253.5c-8.1-1.4-16.3,0.6-25.7,5.9c-0.9,0.5-1.9,1.1-2.9,1.7c-10.6,6.7-19.4,15.7-27.6,28.1\n\t\t\t\t\t\t\t\t\t\tc-8.2,12.4-13.3,24.5-16,37.8c-6.8,33.3,8.5,54.7,34,47.8c4.3-1.2,8.6-3,12.8-5.4c15.8-9.1,30.6-26.7,39.6-48\n\t\t\t\t\t\t\t\t\t\tC798.2,287.7,791.8,257.3,769.6,253.5z M768.8,318.9c-1.1,2.6-2.4,5.2-3.9,7.9c-5.8,10.1-13.4,17.8-21.1,22.2\n\t\t\t\t\t\t\t\t\t\tc-2.6,1.5-5.2,2.6-7.8,3.3c-4.9,1.3-9.5,1-13.4-1.2c-7.9-4.5-10.5-15.7-7.8-28.7c1.3-6.4,3.8-13.2,7.7-19.9\n\t\t\t\t\t\t\t\t\t\tc0.7-1.3,1.5-2.5,2.3-3.7c5-7.6,11.1-13.6,17.2-17.6c0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.8\n\t\t\t\t\t\t\t\t\t\tc1.7,0.3,3.4,0.9,4.9,1.7C775,284,776.3,301.2,768.8,318.9z",
                                                },
                                              }),
                                            ]),
                                            _c("g", { staticClass: "st417" }, [
                                              _c("path", {
                                                staticClass: "st409",
                                                attrs: {
                                                  d: "M770.1,281.3l-10.9-6.3c10.2,5.8,11.6,23.1,4.1,40.7c-1.1,2.6-2.4,5.3-3.9,7.9\n\t\t\t\t\t\t\t\t\t\tc-5.8,10.1-13.5,17.8-21.1,22.3c-2.6,1.5-5.2,2.6-7.8,3.3l10.9,6.3c2.5-0.7,5.2-1.8,7.8-3.3c7.6-4.4,15.3-12.2,21.1-22.3\n\t\t\t\t\t\t\t\t\t\tc1.5-2.6,2.8-5.2,3.9-7.9C781.7,304.3,780.3,287.1,770.1,281.3z",
                                                },
                                              }),
                                              _c("polygon", {
                                                staticClass: "st402",
                                                attrs: {
                                                  points:
                                                    "735.9,352.2 731.3,374.8 736.8,378 741.4,355.4 \t\t\t\t\t\t\t\t\t",
                                                },
                                              }),
                                              _c("path", {
                                                staticClass: "st575",
                                                attrs: {
                                                  d: "M775,256.7c-8.1-1.4-16.3,0.5-25.7,5.9c-1,0.6-1.9,1.1-2.9,1.8c-10.5,6.7-19.4,15.7-27.6,28.1\n\t\t\t\t\t\t\t\t\t\tl11.3,9.5c5-7.6,11.1-13.6,17.2-17.5c0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.9c1.7,0.3,3.4,0.8,4.9,1.7\n\t\t\t\t\t\t\t\t\t\tc10.2,5.8,11.6,23.1,4.1,40.7c-1.1,2.6-2.4,5.3-3.9,7.9c-5.8,10.1-13.5,17.8-21.1,22.3c-2.6,1.5-5.2,2.6-7.8,3.3l-4.6,22.6\n\t\t\t\t\t\t\t\t\t\tc4.3-1.2,8.6-3,12.8-5.4c15.8-9.1,30.5-26.7,39.6-48C803.5,290.8,797.2,260.4,775,256.7z",
                                                },
                                              }),
                                            ]),
                                            _c(
                                              "g",
                                              { staticClass: "st417" },
                                              [
                                                _c("path", {
                                                  staticClass: "st737",
                                                  attrs: {
                                                    d: "M775.5,284.4l-16.3-9.4c10.2,5.8,11.6,23.1,4.1,40.7l16.3,9.4C787.1,307.5,785.7,290.2,775.5,284.4z\n\t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id: "SVGID_00000092431611167776883500000013590115239822910618_",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                      x1: "736.3436",
                                                      y1: "259.385",
                                                      x2: "788.3403",
                                                      y2: "259.385",
                                                    },
                                                  },
                                                  [
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#166250",
                                                      },
                                                      attrs: { offset: "0" },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#196955",
                                                      },
                                                      attrs: {
                                                        offset: "0.1797",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#237B64",
                                                      },
                                                      attrs: {
                                                        offset: "0.4323",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#32997C",
                                                      },
                                                      attrs: {
                                                        offset: "0.7265",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#44BB98",
                                                      },
                                                      attrs: { offset: "1" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c("path", {
                                                  staticStyle: {
                                                    fill: "url(#SVGID_00000092431611167776883500000013590115239822910618_)",
                                                  },
                                                  attrs: {
                                                    d: "M782.8,259.4\n\t\t\t\t\t\t\t\t\t\tc-0.1-0.1-0.2-0.1-0.3-0.2l-5.1-2.9c-0.6-0.3-1.1-0.6-1.7-0.9c0.6,0.3,1.3,0.6,1.9,1l-5.5-3.2c-2.4-1.4-5-2.4-8-2.8\n\t\t\t\t\t\t\t\t\t\tc-8.1-1.4-16.3,0.6-25.7,5.9c-0.7,0.4-1.3,0.8-2,1.2c0.4,0.4,0.9,0.8,1.3,1.2c1,0.9,2.1,1.7,3.1,2.6\n\t\t\t\t\t\t\t\t\t\tc-0.4,0.2-0.7,0.5-1.1,0.7c3.3,2.3,6.6,4.6,10,7c0.7-0.5,1.4-1,2.1-1.4c1-0.6,2-1.2,2.9-1.8c9.3-5.4,17.6-7.3,25.7-5.9\n\t\t\t\t\t\t\t\t\t\tc2.9,0.5,5.6,1.5,8,2.8L782.8,259.4z",
                                                  },
                                                }),
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id: "SVGID_00000133487192820727124100000017286487337530177706_",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                      x1: "724.2114",
                                                      y1: "293.4973",
                                                      x2: "802.2543",
                                                      y2: "293.4973",
                                                    },
                                                  },
                                                  [
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#166250",
                                                      },
                                                      attrs: { offset: "0" },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#196955",
                                                      },
                                                      attrs: {
                                                        offset: "0.1797",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#237B64",
                                                      },
                                                      attrs: {
                                                        offset: "0.4323",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#32997C",
                                                      },
                                                      attrs: {
                                                        offset: "0.7265",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#44BB98",
                                                      },
                                                      attrs: { offset: "1" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c("path", {
                                                  staticStyle: {
                                                    fill: "url(#SVGID_00000133487192820727124100000017286487337530177706_)",
                                                  },
                                                  attrs: {
                                                    d: "M780.3,259.8\n\t\t\t\t\t\t\t\t\t\tc-8.1-1.4-16.3,0.5-25.7,5.9c-1,0.6-1.9,1.1-2.9,1.8c-10.5,6.7-19.4,15.7-27.6,28.1l11.3,9.5c5-7.6,11.1-13.6,17.2-17.5\n\t\t\t\t\t\t\t\t\t\tc0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.9c1.7,0.3,3.4,0.8,4.9,1.7c10.2,5.8,11.6,23.1,4.1,40.7l15.1,2.5\n\t\t\t\t\t\t\t\t\t\tC808.9,293.9,802.5,263.5,780.3,259.8z",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "g",
                                              [
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id: "SVGID_00000032646875180783436490000001873297157099379621_",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                      x1: "713.2887",
                                                      y1: "297.1159",
                                                      x2: "735.44",
                                                      y2: "297.1159",
                                                    },
                                                  },
                                                  [
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#166250",
                                                      },
                                                      attrs: { offset: "0" },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#196955",
                                                      },
                                                      attrs: {
                                                        offset: "0.1797",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#237B64",
                                                      },
                                                      attrs: {
                                                        offset: "0.4323",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#32997C",
                                                      },
                                                      attrs: {
                                                        offset: "0.7265",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#44BB98",
                                                      },
                                                      attrs: { offset: "1" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c("path", {
                                                  staticStyle: {
                                                    fill: "url(#SVGID_00000032646875180783436490000001873297157099379621_)",
                                                  },
                                                  attrs: {
                                                    d: "M735.4,305l-11.2-9.4l-5.5-3.2\n\t\t\t\t\t\t\t\t\t\tc0.1,0.1-5.4-3.1-5.4-3.1l11.3,9.5l5.5,3.2C730.1,301.9,735.4,305,735.4,305L735.4,305z",
                                                  },
                                                }),
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id: "SVGID_00000102510786756526954250000009161795559276568450_",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                      x1: "707.7973",
                                                      y1: "272.7232",
                                                      x2: "780.3114",
                                                      y2: "272.7232",
                                                    },
                                                  },
                                                  [
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#166250",
                                                      },
                                                      attrs: { offset: "0" },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#196955",
                                                      },
                                                      attrs: {
                                                        offset: "0.1797",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#237B64",
                                                      },
                                                      attrs: {
                                                        offset: "0.4323",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#32997C",
                                                      },
                                                      attrs: {
                                                        offset: "0.7265",
                                                      },
                                                    }),
                                                    _c("stop", {
                                                      staticStyle: {
                                                        "stop-color": "#44BB98",
                                                      },
                                                      attrs: { offset: "1" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c("path", {
                                                  staticStyle: {
                                                    fill: "url(#SVGID_00000102510786756526954250000009161795559276568450_)",
                                                  },
                                                  attrs: {
                                                    d: "M763.9,250.3\n\t\t\t\t\t\t\t\t\t\tc-8.1-1.4-16.3,0.5-25.7,5.9c-1,0.6-1.9,1.1-2.9,1.8c-10.5,6.7-19.4,15.7-27.6,28.1l16.4,9.5c8.2-12.4,17-21.4,27.6-28.1\n\t\t\t\t\t\t\t\t\t\tc1-0.6,2-1.2,2.9-1.8c9.3-5.4,17.6-7.3,25.7-5.9L763.9,250.3z",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M762.3,256.4c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.1-0.7,0.2-0.8L856,201l10.6-39.6\n\t\t\t\t\t\t\t\t\tc0-0.2,0.1-0.3,0.3-0.4l70.4-40.6c0.3-0.2,0.7-0.1,0.8,0.2c0.2,0.3,0.1,0.7-0.2,0.8l-70.1,40.5l-10.6,39.6\n\t\t\t\t\t\t\t\t\tc0,0.2-0.1,0.3-0.3,0.4l-94.2,54.4C762.5,256.4,762.4,256.4,762.3,256.4z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M796.9,288c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.1-0.7,0.2-0.8l59.6-34.4l4.1-15.1\n\t\t\t\t\t\t\t\t\tc0-0.2,0.1-0.3,0.3-0.4l44.9-25.9c0.3-0.2,0.7-0.1,0.8,0.2c0.2,0.3,0.1,0.7-0.2,0.8l-44.7,25.8l-4.1,15.1\n\t\t\t\t\t\t\t\t\tc0,0.2-0.1,0.3-0.3,0.4l-59.8,34.5C797.1,288,797,288,796.9,288z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M759.2,356c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.1-0.7,0.2-0.8l71.4-41.2c0.1-0.1,0.3-0.1,0.5-0.1\n\t\t\t\t\t\t\t\t\tl25.3,6.8l43.6-25.1c0.3-0.2,0.7-0.1,0.8,0.2c0.2,0.3,0.1,0.7-0.2,0.8l-43.8,25.3c-0.1,0.1-0.3,0.1-0.5,0.1l-25.3-6.8\n\t\t\t\t\t\t\t\t\tL759.5,356C759.4,356,759.3,356,759.2,356z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "878,139.3 866.6,145.8 866.6,140.7 878,134.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "910.9,120.3 882.9,136.4 882.9,131.3 910.9,115.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "926.8,111.1 915.8,117.4 915.8,112.3 926.8,106 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "890.2,141.7 866.6,155.3 866.6,150.2 890.2,136.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "902.4,134.6 895.1,138.8 895.1,133.7 902.4,129.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "919.8,124.6 907.3,131.8 907.3,126.7 919.8,119.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "871.5,215.3 860.2,221.8 860.2,216.7 871.5,210.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "890,204.6 876.5,212.4 876.5,207.3 890,199.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "905.6,195.6 895,201.7 895,196.6 905.6,190.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "883.7,217.7 860.2,231.3 860.2,226.2 883.7,212.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "901.3,207.5 888.7,214.8 888.7,209.7 901.3,202.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "867.6,298.5 856.3,305.1 856.3,300 867.6,293.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "900.5,279.5 872.6,295.7 872.6,290.6 900.5,274.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "879.8,300.9 856.3,314.5 856.3,309.4 879.8,295.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st702",
                                              attrs: {
                                                points:
                                                  "892,293.9 884.8,298.1 884.8,293 892,288.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                        ]),
                                        _c("path", {
                                          staticClass: "st780",
                                          attrs: {
                                            d: "M353.6,767.4l66.1-38.1l-54.5-76.5c-0.8-1.2-2.3-1.2-3.7-0.3c-1.4,0.8-2.9,2.5-3.7,4.6l-4.2,10.9\n\t\t\t\t\t\t\tL353.6,767.4z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st781",
                                          attrs: {
                                            d: "M730.2,423.9c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8\n\t\t\t\t\t\t\tc-0.6,0.4-1-0.2-0.7-1l11.1-28.5C729.7,424.4,730,424.1,730.2,423.9z M729.5,459.4L718.5,488c-0.3,0.8,0.1,1.4,0.7,1\n\t\t\t\t\t\t\tl22.2-12.8c0.6-0.4,1-1.4,0.7-1.8L731,458.6c-0.2-0.2-0.4-0.2-0.7-0.1C730,458.7,729.7,459,729.5,459.4z M729.5,494.1\n\t\t\t\t\t\t\tl-11.1,28.5c-0.3,0.8,0.1,1.4,0.7,1l22.2-12.8c0.6-0.4,1-1.4,0.7-1.8L731,493.2c-0.2-0.2-0.4-0.2-0.7-0.1\n\t\t\t\t\t\t\tC730,493.3,729.7,493.7,729.5,494.1z",
                                          },
                                        }),
                                        _c("g", [
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "415.5,615.4 404.7,621.7 404.7,616.8 415.5,610.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "446.7,597.4 420.2,612.7 420.2,607.9 446.7,592.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "461.8,588.7 451.4,594.7 451.4,589.9 461.8,583.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "427,617.7 404.7,630.6 404.7,625.8 427,612.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "438.6,611.1 431.7,615 431.7,610.2 438.6,606.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "455.2,601.5 443.3,608.3 443.3,603.5 455.2,596.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "494.3,569.9 483.5,576.1 483.5,571.3 494.3,565.1 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "525.5,551.9 499,567.2 499,562.4 525.5,547 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "505.9,572.2 483.5,585.1 483.5,580.3 505.9,567.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "517.5,565.5 510.6,569.5 510.6,564.7 517.5,560.7 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "573.9,524 563.2,530.2 563.2,525.3 573.9,519.1 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "605.2,505.9 578.6,521.2 578.6,516.4 605.2,501.1 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "609.9,498.4 609.9,503.2 620.3,497.2 620.3,492.3 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "585.5,526.2 563.2,539.2 563.2,534.3 585.5,521.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "597.1,519.6 590.2,523.5 590.2,518.7 597.1,514.7 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "415.5,646.9 404.7,653.1 404.7,648.2 415.5,642 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "439,633.3 420.2,644.2 420.2,639.3 439,628.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "456.2,623.4 443.7,630.6 443.7,625.7 456.2,618.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "427,649.2 404.7,662.1 404.7,657.2 427,644.3 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "449.9,636 431.7,646.5 431.7,641.6 449.9,631.1 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "494.3,601.3 483.5,607.6 483.5,602.7 494.3,596.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "510.8,591.8 499,598.6 499,593.8 510.8,587 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "505.9,603.6 483.5,616.6 483.5,611.7 505.9,598.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "573.9,555.4 563.2,561.6 563.2,556.7 573.9,550.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "595.8,542.8 578.6,552.7 578.6,547.8 595.8,537.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "613.7,532.4 600.6,540 600.6,535.1 613.7,527.6 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "585.5,557.7 563.2,570.6 563.2,565.7 585.5,552.8 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "415.5,678.3 404.7,684.5 404.7,679.6 415.5,673.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "446.7,660.2 420.2,675.6 420.2,670.7 446.7,655.4 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "427,680.6 404.7,693.5 404.7,688.6 427,675.7 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "438.6,673.9 431.7,677.9 431.7,673 438.6,669 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "494.3,632.8 483.5,639 483.5,634.1 494.3,627.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "525.5,614.7 499,630.1 499,625.2 525.5,609.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "540.6,606 530.2,612 530.2,607.2 540.6,601.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "505.9,635.1 483.5,648 483.5,643.1 505.9,630.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "517.5,628.4 510.6,632.4 510.6,627.5 517.5,623.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "573.9,586.8 563.2,593 563.2,588.2 573.9,581.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "605.2,568.8 578.6,584.1 578.6,579.2 605.2,563.9 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "585.5,589.1 563.2,602 563.2,597.1 585.5,584.2 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                            _c("polygon", {
                                              staticClass: "st773",
                                              attrs: {
                                                points:
                                                  "597.1,582.4 590.2,586.4 590.2,581.5 597.1,577.5 \t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "643.6,481 639,483.6 639,481.6 643.6,479 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "658.5,472.4 645.5,479.9 645.5,477.9 658.5,470.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "664.8,468.8 660.4,471.3 660.4,469.3 664.8,466.7 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "648.4,482 639,487.4 639,485.4 648.4,480 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "653.3,479.2 650.4,480.9 650.4,478.8 653.3,477.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "662,474.1 655.3,478 655.3,476 662,472.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "669.8,465.9 667.1,467.5 667.1,465.4 669.8,463.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "683,458.3 671.8,464.7 671.8,462.7 683,456.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "674.7,466.8 664.2,472.9 664.2,470.9 674.7,464.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "679.6,464 676.7,465.7 676.7,463.7 679.6,462 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "690.2,454.1 685.6,456.7 685.6,454.7 690.2,452.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "703.3,446.6 692.1,453 692.1,451 703.3,444.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "705.3,443.4 705.3,445.4 709.6,442.9 709.6,440.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "695,455.1 682,462.6 682,460.6 695,453.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "699.9,452.3 697,454 697,451.9 699.9,450.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "643.6,489 639,491.6 639,489.5 643.6,486.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "658.5,480.4 645.5,487.8 645.5,485.8 658.5,478.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "664.8,476.7 660.4,479.2 660.4,477.2 664.8,474.7 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "648.4,489.9 639,495.3 639,493.3 648.4,487.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "653.3,487.1 650.4,488.8 650.4,486.7 653.3,485.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "662,482.1 655.3,486 655.3,483.9 662,480 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "669.8,473.8 667.1,475.4 667.1,473.4 669.8,471.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "683,466.2 671.8,472.7 671.8,470.6 683,464.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "674.7,474.8 664.2,480.8 664.2,478.8 674.7,472.7 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "679.6,472 676.7,473.6 676.7,471.6 679.6,469.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "690.2,462.1 685.6,464.7 685.6,462.6 690.2,460 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                          ]),
                                          _c("g", [
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "643.6,512.4 639,515 639,513 643.6,510.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "658.5,503.8 645.5,511.3 645.5,509.2 658.5,501.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "664.8,500.1 660.4,502.7 660.4,500.6 664.8,498.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "648.4,513.4 639,518.8 639,516.7 648.4,511.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "653.3,510.6 650.4,512.2 650.4,510.2 653.3,508.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "662,505.5 655.3,509.4 655.3,507.4 662,503.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "669.8,497.2 667.1,498.8 667.1,496.8 669.8,495.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "683,489.7 671.8,496.1 671.8,494.1 683,487.6 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "674.7,498.2 664.2,504.3 664.2,502.2 674.7,496.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "679.6,495.4 676.7,497.1 676.7,495 679.6,493.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "690.2,485.5 685.6,488.1 685.6,486.1 690.2,483.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "703.3,477.9 692.1,484.4 692.1,482.3 703.3,475.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "705.3,474.7 705.3,476.8 709.6,474.3 709.6,472.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "695,486.5 682,494 682,492 695,484.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "699.9,483.6 697,485.3 697,483.3 699.9,481.6 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "643.6,520.3 639,522.9 639,520.9 643.6,518.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "658.5,511.7 645.5,519.2 645.5,517.1 658.5,509.7 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "664.8,508.1 660.4,510.6 660.4,508.5 664.8,506 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "669.8,505.2 667.1,506.8 667.1,504.7 669.8,503.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "683,497.6 671.8,504 671.8,502 683,495.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "704,485.4 692.9,491.9 692.9,489.8 704,483.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "690.2,493.4 685.6,496 685.6,494 690.2,491.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                          ]),
                                          _c("g", [
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "643.6,544 639,546.6 639,544.6 643.6,542 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "658.5,535.4 645.5,542.9 645.5,540.8 658.5,533.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "664.8,531.7 660.4,534.3 660.4,532.2 664.8,529.7 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "648.4,545 639,550.4 639,548.3 648.4,542.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "653.3,542.1 650.4,543.8 650.4,541.8 653.3,540.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "662,537.1 655.3,541 655.3,539 662,535.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "669.8,528.8 667.1,530.4 667.1,528.4 669.8,526.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "683,521.3 671.8,527.7 671.8,525.7 683,519.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "674.7,529.8 664.2,535.8 664.2,533.8 674.7,527.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "679.6,527 676.7,528.7 676.7,526.6 679.6,524.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "690.2,517.1 685.6,519.7 685.6,517.7 690.2,515.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "703.3,509.5 692.1,516 692.1,513.9 703.3,507.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "705.3,506.3 705.3,508.4 709.6,505.8 709.6,503.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "695,518.1 682,525.6 682,523.6 695,516 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "707.5,510.8 697,516.9 697,514.9 707.5,508.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "643.6,551.9 639,554.5 639,552.5 643.6,549.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "658.5,543.3 645.5,550.8 645.5,548.7 658.5,541.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "664.8,539.7 660.4,542.2 660.4,540.1 664.8,537.6 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "648.4,552.9 639,558.3 639,556.3 648.4,550.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "653.3,550.1 650.4,551.7 650.4,549.7 653.3,548 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "662,545 655.3,548.9 655.3,546.9 662,543 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "669.8,536.8 667.1,538.4 667.1,536.3 669.8,534.7 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "683,529.2 671.8,535.6 671.8,533.6 683,527.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "690.2,525 685.6,527.6 685.6,525.6 690.2,523 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                          ]),
                                          _c("g", [
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "758.8,414.5 754.3,417.1 754.3,415.1 758.8,412.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "773.7,405.9 760.8,413.4 760.8,411.3 773.7,403.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "780,402.2 775.7,404.8 775.7,402.7 780,400.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "763.7,415.5 754.3,420.9 754.3,418.8 763.7,413.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "768.5,412.7 765.6,414.3 765.6,412.3 768.5,410.6 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "777.3,407.6 770.5,411.5 770.5,409.5 777.3,405.6 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "785.1,399.3 782.3,400.9 782.3,398.9 785.1,397.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "758.8,422.4 754.3,425 754.3,423 758.8,420.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "773.7,413.8 760.8,421.3 760.8,419.3 773.7,411.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "780,410.2 775.7,412.7 775.7,410.7 780,408.1 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "763.7,423.4 754.3,428.8 754.3,426.8 763.7,421.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "768.5,420.6 765.6,422.3 765.6,420.2 768.5,418.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "777.3,415.5 770.5,419.4 770.5,417.4 777.3,413.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                          ]),
                                          _c("g", [
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "758.8,445.9 754.3,448.5 754.3,446.4 758.8,443.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "773.7,437.3 760.8,444.7 760.8,442.7 773.7,435.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "780,433.6 775.7,436.1 775.7,434.1 780,431.6 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "763.7,446.8 754.3,452.3 754.3,450.2 763.7,444.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "768.5,444 765.6,445.7 765.6,443.7 768.5,442 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "777.3,439 770.5,442.9 770.5,440.8 777.3,436.9 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "785.1,430.7 782.3,432.3 782.3,430.3 785.1,428.7 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "758.8,453.8 754.3,456.4 754.3,454.4 758.8,451.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "773.7,445.2 760.8,452.7 760.8,450.6 773.7,443.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                          ]),
                                          _c("g", [
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "758.8,477.5 754.3,480.1 754.3,478 758.8,475.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "773.7,468.9 760.8,476.3 760.8,474.3 773.7,466.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "780,465.2 775.7,467.7 775.7,465.7 780,463.2 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "763.7,478.4 754.3,483.8 754.3,481.8 763.7,476.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "768.5,475.6 765.6,477.3 765.6,475.3 768.5,473.6 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "777.3,470.6 770.5,474.5 770.5,472.4 777.3,468.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "785.1,462.3 782.3,463.9 782.3,461.9 785.1,460.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("g", [
                                              _c("g", [
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "758.8,485.4 754.3,488 754.3,486 758.8,483.4 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "773.7,476.8 760.8,484.3 760.8,482.2 773.7,474.8 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "763.7,486.4 754.3,491.8 754.3,489.7 763.7,484.3 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                                _c("polygon", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    points:
                                                      "768.5,483.5 765.6,485.2 765.6,483.2 768.5,481.5 \t\t\t\t\t\t\t\t\t\t",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                          ]),
                                          _c("g", [
                                            _c("g", { staticClass: "st417" }, [
                                              _c("path", {
                                                staticClass: "st782",
                                                attrs: {
                                                  d: "M738.1,418.3c-0.2-0.1-0.4-0.1-0.6,0.1c-0.3,0.2-0.6,0.5-0.7,0.9l-11.1,28.5\n\t\t\t\t\t\t\t\t\t\tc-0.2,0.5-0.1,0.9,0.1,1.1l3.1,1.8l12.2-30.6L738.1,418.3z",
                                                },
                                              }),
                                              _c("g", [
                                                _c("path", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    d: "M740.6,420.1c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8\n\t\t\t\t\t\t\t\t\t\t\tc-0.6,0.4-1-0.2-0.7-1l11.1-28.5C740,420.6,740.3,420.3,740.6,420.1z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("path", {
                                              staticClass: "st783",
                                              attrs: {
                                                d: "M741.6,438.2c0.5,0,0.7,0.7,0.4,1.5c-0.2,0.5-0.6,0.9-0.9,1.2c-0.2,0.1-0.4,0.2-0.5,0.1\n\t\t\t\t\t\t\t\t\tc-0.5,0-0.7-0.7-0.4-1.5c0.2-0.5,0.6-0.9,0.9-1.2C741.2,438.3,741.4,438.2,741.6,438.2z M742.1,429c0-1.8-0.6-2.4-1.1-2.1\n\t\t\t\t\t\t\t\t\tc-0.6,0.3-1.1,1.6-1.1,3.4c0,3.7,0.5,7.2,1.1,6.8C741.6,436.8,742.1,432.7,742.1,429z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("g", { staticClass: "st417" }, [
                                              _c("path", {
                                                staticClass: "st782",
                                                attrs: {
                                                  d: "M738.1,452.9c-0.2-0.1-0.4-0.1-0.6,0.1c-0.3,0.2-0.6,0.5-0.7,0.9l-11.1,28.5\n\t\t\t\t\t\t\t\t\t\tc-0.2,0.5-0.1,0.9,0.1,1.1l3.1,1.8l12.2-30.6L738.1,452.9z",
                                                },
                                              }),
                                              _c("g", [
                                                _c("path", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    d: "M740.6,454.7c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8\n\t\t\t\t\t\t\t\t\t\t\tc-0.6,0.4-1-0.2-0.7-1l11.1-28.5C740,455.2,740.3,454.9,740.6,454.7z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("path", {
                                              staticClass: "st783",
                                              attrs: {
                                                d: "M741.6,472.9c0.5,0,0.7,0.7,0.4,1.5c-0.2,0.5-0.6,0.9-0.9,1.2c-0.2,0.1-0.4,0.2-0.5,0.1\n\t\t\t\t\t\t\t\t\tc-0.5,0-0.7-0.7-0.4-1.5c0.2-0.5,0.6-0.9,0.9-1.2C741.2,472.9,741.4,472.8,741.6,472.9z M742.1,463.7c0-1.8-0.6-2.4-1.1-2.1\n\t\t\t\t\t\t\t\t\tc-0.6,0.3-1.1,1.6-1.1,3.4c0,3.7,0.5,7.2,1.1,6.8C741.6,471.4,742.1,467.4,742.1,463.7z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("g", { staticClass: "st417" }, [
                                              _c("path", {
                                                staticClass: "st782",
                                                attrs: {
                                                  d: "M738.1,487.5c-0.2-0.1-0.4-0.1-0.6,0.1c-0.3,0.2-0.6,0.5-0.7,0.9L725.7,517\n\t\t\t\t\t\t\t\t\t\tc-0.2,0.5-0.1,0.9,0.1,1.1l3.1,1.8l12.2-30.6L738.1,487.5z",
                                                },
                                              }),
                                              _c("g", [
                                                _c("path", {
                                                  staticClass: "st773",
                                                  attrs: {
                                                    d: "M740.6,489.4c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8\n\t\t\t\t\t\t\t\t\t\t\tc-0.6,0.4-1-0.2-0.7-1l11.1-28.5C740,489.9,740.3,489.5,740.6,489.4z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _c("path", {
                                              staticClass: "st783",
                                              attrs: {
                                                d: "M741.6,507.5c0.5,0,0.7,0.7,0.4,1.5c-0.2,0.5-0.6,0.9-0.9,1.2c-0.2,0.1-0.4,0.2-0.5,0.1\n\t\t\t\t\t\t\t\t\tc-0.5,0-0.7-0.7-0.4-1.5c0.2-0.5,0.6-0.9,0.9-1.2C741.2,507.5,741.4,507.5,741.6,507.5z M742.1,498.3c0-1.8-0.6-2.4-1.1-2.1\n\t\t\t\t\t\t\t\t\tc-0.6,0.3-1.1,1.6-1.1,3.4c0,3.7,0.5,7.2,1.1,6.8C741.6,506,742.1,502,742.1,498.3z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                      ]),
                                      _c("path", {
                                        staticClass: "st784",
                                        attrs: {
                                          d: "M408.7,404.3c0,2.5-2,5.7-4.5,7.2c-2.5,1.5-4.5,0.6-4.5-1.9s2-5.7,4.5-7.2\n\t\t\t\t\t\tC406.7,400.9,408.7,401.8,408.7,404.3z M388,411.7c-2.5,1.5-4.5,4.7-4.5,7.2c0,2.5,2,3.4,4.5,1.9c2.5-1.5,4.5-4.7,4.5-7.2\n\t\t\t\t\t\tS390.5,410.3,388,411.7z M371.8,421.1c-2.5,1.5-4.5,4.7-4.5,7.2s2,3.4,4.5,1.9c2.5-1.5,4.5-4.7,4.5-7.2\n\t\t\t\t\t\tS374.3,419.6,371.8,421.1z",
                                        },
                                      }),
                                      _c("g", [
                                        _c("g", { staticClass: "st417" }, [
                                          _c("path", {
                                            staticClass: "st772",
                                            attrs: {
                                              d: "M376.7,659.1c-0.8-0.5-1.9-0.3-3,0.3c-1.4,0.8-2.9,2.5-3.7,4.6l-56.8,146.7c-1,2.6-0.6,4.8,0.7,5.5\n\t\t\t\t\t\t\t\tl9.9,5.7l62.8-157.1L376.7,659.1z",
                                            },
                                          }),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st717",
                                              attrs: {
                                                d: "M383.6,665.2c1.4-0.8,2.9-0.8,3.7,0.3l57.5,80.7c1.6,2.3-0.4,7.6-3.7,9.5l-114.3,66\n\t\t\t\t\t\t\t\t\tc-3.3,1.9-5.3-1-3.7-5.2l56.8-146.7C380.8,667.7,382.2,666,383.6,665.2z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                        _c("path", {
                                          staticClass: "st785",
                                          attrs: {
                                            d: "M388.9,758.3c2.6,0.2,3.5,3.6,2,7.5c-1,2.6-2.9,4.8-4.8,5.9c-0.9,0.5-1.9,0.8-2.7,0.7\n\t\t\t\t\t\t\tc-2.7-0.2-3.6-3.6-2-7.5c1-2.6,2.9-4.8,4.8-5.9C387,758.5,388,758.2,388.9,758.3z M391.7,711.1c0-9.4-2.9-12.5-5.7-10.9\n\t\t\t\t\t\t\tc-2.8,1.6-5.7,8-5.7,17.4c0.1,18.9,2.7,36.8,5.8,35C389.2,750.8,391.7,730,391.7,711.1z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("g", [
                                        _c(
                                          "g",
                                          { staticClass: "st417" },
                                          [
                                            _c(
                                              "linearGradient",
                                              {
                                                attrs: {
                                                  id: "SVGID_00000080165539702922976100000010748310827441185464_",
                                                  gradientUnits:
                                                    "userSpaceOnUse",
                                                  x1: "810.4519",
                                                  y1: "620.4432",
                                                  x2: "907.5024",
                                                  y2: "620.4432",
                                                },
                                              },
                                              [
                                                _c("stop", {
                                                  staticStyle: {
                                                    "stop-color": "#1F715C",
                                                  },
                                                  attrs: {
                                                    offset: "1.071477e-03",
                                                  },
                                                }),
                                                _c("stop", {
                                                  staticStyle: {
                                                    "stop-color": "#237761",
                                                  },
                                                  attrs: { offset: "0.2003" },
                                                }),
                                                _c("stop", {
                                                  staticStyle: {
                                                    "stop-color": "#2D8A70",
                                                  },
                                                  attrs: { offset: "0.4783" },
                                                }),
                                                _c("stop", {
                                                  staticStyle: {
                                                    "stop-color": "#3DA788",
                                                  },
                                                  attrs: { offset: "0.8012" },
                                                }),
                                                _c("stop", {
                                                  staticStyle: {
                                                    "stop-color": "#49BD99",
                                                  },
                                                  attrs: { offset: "1" },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("path", {
                                              staticStyle: {
                                                fill: "url(#SVGID_00000080165539702922976100000010748310827441185464_)",
                                              },
                                              attrs: {
                                                d: "M899.5,621l-67-40.8l-22.1,37.7\n\t\t\t\t\t\t\t\tl67,40.8c8.5,4.9,20.4,0.5,26.5-9.9C910.1,638.4,908.1,625.9,899.5,621z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st737",
                                              attrs: {
                                                d: "M832.5,580.2c-8.6-4.9-20.4-0.5-26.5,9.9c-6.1,10.4-4.1,22.8,4.5,27.8c2,1.2,4.2,1.8,6.5,2\n\t\t\t\t\t\t\t\tc7.3,0.5,15.4-3.9,20-11.9c4.8-8.3,4.6-17.8,0-23.8C835.8,582.6,834.3,581.2,832.5,580.2z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st750",
                                              attrs: {
                                                d: "M837,584.2c8.4,13.7-3.9,35.4-20,35.7C834.9,622.4,848.9,598,837,584.2z",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st787",
                                            attrs: {
                                              d: "M825.7,586.3l-21.5-13.1c-1.5,2.2-3,4.3-4.3,6.4c-3.4,5.3-7.5,9.8-11.5,14.3l24.2,14.7\n\t\t\t\t\t\t\t\tc5.1,2.9,12.1,0.3,15.7-5.9C831.9,596.6,830.7,589.2,825.7,586.3z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c(
                                        "g",
                                        { staticClass: "st417" },
                                        [
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id: "SVGID_00000167368190822859668150000005138660260904031362_",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "833.7596",
                                                y1: "478.671",
                                                x2: "757.2897",
                                                y2: "611.1207",
                                              },
                                            },
                                            [
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#C4BBB6",
                                                },
                                                attrs: { offset: "0" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#D2CBC5",
                                                },
                                                attrs: { offset: "0.2398" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#E9E4DF",
                                                },
                                                attrs: { offset: "0.7154" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#F1EEE8",
                                                },
                                                attrs: { offset: "1" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("path", {
                                            staticStyle: {
                                              fill: "url(#SVGID_00000167368190822859668150000005138660260904031362_)",
                                            },
                                            attrs: {
                                              d: "M830.1,480.3\n\t\t\t\t\t\t\tc-3-4.2-6.5-7.4-10.5-9.7l-18.7-10.9c4,2.3,7.5,5.6,10.5,9.7c9,12.7,11.5,32.2,6.9,54.9c-4.6,22.7-15.7,45.9-31.3,65.3\n\t\t\t\t\t\t\tc-10.4,12.9-21.9,23.1-33.6,29.8c-5.9,3.4-11.7,5.9-17.6,7.5c-11.7,3.2-22.1,2.2-30.5-2.6l18.7,10.9\n\t\t\t\t\t\t\tc8.3,4.8,18.8,5.8,30.5,2.6c5.8-1.6,11.7-4.1,17.6-7.5c11.7-6.8,23.2-16.9,33.6-29.8c15.6-19.4,26.7-42.5,31.3-65.3\n\t\t\t\t\t\t\tC841.6,512.5,839.1,493,830.1,480.3z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st789",
                                            attrs: {
                                              d: "M831.9,532.2c-4.6,22.7-15.8,45.9-31.3,65.3c-10.4,12.9-21.9,23.1-33.6,29.8\n\t\t\t\t\t\t\tc-5.9,3.4-11.7,5.9-17.6,7.5c-17.4,4.7-32,0.3-41.1-12.5c-18.7-26.3-7.8-80.2,24.4-120.2c10.6-13.2,22.2-23.2,33.6-29.8\n\t\t\t\t\t\t\tc23.3-13.5,46.1-12.7,58.7,5C834,490,836.5,509.6,831.9,532.2z",
                                            },
                                          }),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id: "SVGID_00000156581010094061788590000001852340753716620962_",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "787.8976",
                                                y1: "444.511",
                                                x2: "686.076",
                                                y2: "620.8713",
                                              },
                                            },
                                            [
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#F7F4F3",
                                                },
                                                attrs: { offset: "0" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#F2EEF0",
                                                },
                                                attrs: { offset: "0.1286" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#E3DDE8",
                                                },
                                                attrs: { offset: "0.2988" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#CAC2DA",
                                                },
                                                attrs: { offset: "0.4921" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#A79CC7",
                                                },
                                                attrs: { offset: "0.7026" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#7B6BAF",
                                                },
                                                attrs: { offset: "0.9247" },
                                              }),
                                              _c("stop", {
                                                staticStyle: {
                                                  "stop-color": "#6B59A6",
                                                },
                                                attrs: { offset: "1" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("path", {
                                            staticStyle: {
                                              fill: "url(#SVGID_00000156581010094061788590000001852340753716620962_)",
                                            },
                                            attrs: {
                                              d: "M804.2,453.9\n\t\t\t\t\t\t\tc-13.8-8-32.5-5.9-51.5,5.1c-12.2,7.1-24.6,17.8-35.9,31.9c-34.4,42.8-46.1,100.4-26.1,128.5c3.2,4.5,7,8,11.3,10.5l18.7,10.9\n\t\t\t\t\t\t\tc-4.3-2.5-8.2-6-11.3-10.5c-20-28.1-8.3-85.8,26.1-128.5c11.3-14.1,23.7-24.8,35.9-31.9c19.1-11,37.8-13.1,51.5-5.1\n\t\t\t\t\t\t\tL804.2,453.9z",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st787",
                                            attrs: {
                                              d: "M834.1,475.2c-13.4-18.9-37.8-19.7-62.8-5.3c-12.2,7.1-24.6,17.8-35.9,31.9\n\t\t\t\t\t\t\tc-12.6,15.7-22.2,33.5-28.3,51c-10.4,30.2-10.5,59.8,2.2,77.5c9.7,13.7,25.3,18.4,43.9,13.4c6.2-1.7,12.5-4.4,18.8-8\n\t\t\t\t\t\t\tc12.5-7.2,24.8-18.1,35.9-31.9c16.7-20.7,28.6-45.5,33.5-69.8C846.4,509.7,843.8,488.8,834.1,475.2z M837,535.2\n\t\t\t\t\t\t\tc-4.6,22.7-15.8,45.9-31.3,65.3c-10.4,12.9-21.9,23.1-33.6,29.8c-5.9,3.4-11.7,5.9-17.6,7.5c-17.4,4.7-32,0.3-41.1-12.5\n\t\t\t\t\t\t\tc-18.7-26.3-7.8-80.2,24.4-120.2c10.6-13.2,22.2-23.2,33.6-29.8c23.3-13.5,46.1-12.7,58.7,5C839.1,493,841.6,512.5,837,535.2z\n\t\t\t\t\t\t\t",
                                            },
                                          }),
                                          _c("path", {
                                            staticClass: "st772",
                                            attrs: {
                                              d: "M815.3,461.5c-1.1-0.4-2.7-0.8-4.8-1.2c-4.2-0.8-10.4-1.2-17.6,0.3c-7.2,1.4-15.3,4.5-23.2,9.1\n\t\t\t\t\t\t\tc-7.9,4.6-15.6,10.7-22.6,17.4c-6.9,6.8-13.1,14.4-18.4,21.8c-5.3,7.4-9.4,14.9-12.6,21.4c-3.2,6.5-5.4,12.2-6.8,16.2\n\t\t\t\t\t\t\tc-1.4,4-2.1,6.3-2.1,6.3s0.8-2.3,2.5-6.2c1.6-3.9,4.2-9.3,7.7-15.7c3.4-6.4,7.9-13.5,13.2-20.8c5.3-7.3,11.5-14.7,18.4-21.3\n\t\t\t\t\t\t\tc13.5-13.6,30.4-23.8,44.4-27c7-1.7,13.1-1.8,17.2-1.2c2.1,0.2,3.7,0.6,4.8,0.9c1.1,0.3,1.7,0.5,1.7,0.5\n\t\t\t\t\t\t\tS816.4,461.9,815.3,461.5z",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("BI & Analytics")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }